const MINIMUM_TIME = 2000; // at least 2 seconds, Galaxy requested

let didLoad = false;

/**
 * initialize load curtain
 */
export default class LoadCurtain {
  constructor($element) {
    this.$element = $element;
    this.isMinTime = false;
    this.isLoaded = document.readyState === 'complete';

    // YOLO you only load once. Reveal immediately
    if (didLoad) {
      this.reveal();
      return;
    }

    didLoad = true;

    // check if loaded & min time then remove curtain
    if (!this.isLoaded) {
      window.addEventListener('load', () => {
        this.isLoaded = true;
        this.checkLoad();
      });
    }

    setTimeout(() => {
      this.isMinTime = true;
      this.checkLoad();
    }, MINIMUM_TIME);
  }

  checkLoad() {
    // needs to be loaded and minimum time
    if (this.isLoaded && this.isMinTime) {
      this.reveal();
    }
  }

  reveal() {
    this.$element.addEventListener('transitionend', () => {
      this.$element.remove();
    });
    document.body.classList.remove('isLoading');
  }

  unmount() {}
}
